import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/slider/1.png'


const _withScopeId = n => (_pushScopeId("data-v-5252793b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"font-size":"35px","font-weight":"bold"},
  class: "mb-6"
}, "Jtel Broadband FAQs on New Connection", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, [
  /*#__PURE__*/_createTextVNode("Steps to buy Jtel new broadband connection:- "),
  /*#__PURE__*/_createElementVNode("ul", { class: "ml-10 mt-2" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" Visit "),
      /*#__PURE__*/_createElementVNode("a", { href: "https://jtel.in/" }, "Jtel"),
      /*#__PURE__*/_createTextVNode(" webpage ")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, " Select best internet plan "),
    /*#__PURE__*/_createElementVNode("li", null, " Fill the form and submit it, after that you will get a call from our sales teams. After your confirmation of order, new broadband connection installed at your preferred address ")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "Within 48 hours new broadband connection becomes active. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "It will be provided free of cost irrespective of any Jtel broadband plan you may choose annual subscription. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "Broadband Internet will give you a better overall experience than a dongle. Dongles are normally portable Internet connections that you plug directly into your laptop or desktop computer. Meanwhile, broadband Internet connections are provided for multiple devices and are laid out over fiber optic cables. I suggest you take up Jtel broadband for your home, because you will get a really good deal on the plan. ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "The speed of internet shall vary as per your exact location. It will be confirmed before installation process. ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "Wifi is a technology that uses a router to create a Wireless Local Area Network (WLAN) to connect devices such as computers, tablets and smartphones with one another. This technology uses radio waves and does not require an Internet connection. Broadband is the technology that connects a home computer or network to the Internet using cables, ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "The Jtel Broadband employs the most modern broadband technology called Jtel Smart Fiber with the fiber optic connectivity with speed up to 1 Gbps. The Jtel broadband connections also come with their own free router, ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "You can have a wifi network without the broadband, however without the internet connectivity the wifi will have some very limited features. You can use it to interact with other devices at home and use it for things like offline file transfer, streaming media to other devices, and controlling your computer remotely. ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "The broadband connection does not require a phone ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "While both wifi and broadband have their own benefits, the broadband is a better choice for majority of the users since it provides faster speeds. The broadband connection is also less susceptible to being hacked since it is more secure. ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "You can check the Jtel Broadband usage through the Jtel app. Once you have logged into your account using the registered mobile number,you will get the various accounts access,Your usage of broadband will be displayed there as well as your outstanding bills. ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "You can buy the Jtel Broadband connection in just three easy steps. First you need to open the Jtel broadband page on your computer or smart device, choose your city and the broadband plan that you wish to opt for. You will be directed to a different page where you need to provide your details and you will receive a call from the installation team regarding your convenient installation time and location. ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "All the Jtel Broadband connections come with the free wifi router and therefore the customers can use it wirelessly. ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "Post-paid Any scheme change/reconnection/shifting/disconnection/ transfer will be acted based on the written request from the customer along with dues settlement. ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "The Jtel Fiber promises higher speed and more stable connection due to the Fiber Optic technology used by Jtel in comparison to the traditional cables. The router is also better with Gigabit ports to accommodate the Jtel internet speeds that go up to 1 Gbps. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_jt_need_guidance = _resolveComponent("jt-need-guidance")!
  const _component_jt_footer = _resolveComponent("jt-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { class: "mt-3" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "d-flex justify-center cursor-pointer" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, { src: _imports_0 })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "mt-5 mx-0 mx-md-8" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          style: {"font-size":"15px"}
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createVNode(_component_v_expansion_panels, { variant: "accordion" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_expansion_panel, { title: "How to buy a new broadband connection?" }, {
                  text: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_expansion_panel, { title: "How long does it take for new broadband connection to become active?" }, {
                  text: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_expansion_panel, { title: "How much to pay for the broadband router?" }, {
                  text: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_expansion_panel, { title: "Should I choose broadband Internet or stick to dongle?" }, {
                  text: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_expansion_panel, { title: "Will I get the maximum broadband speed promised in the plan?" }, {
                  text: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_expansion_panel, { title: "How is broadband different from WiFi?" }, {
                  text: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_expansion_panel, { title: "Why is Jtel broadband best for home?" }, {
                  text: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_expansion_panel, { title: "Do you need broadband to have WiFi?" }, {
                  text: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_expansion_panel, { title: "Does broadband Internet need a phone line?" }, {
                  text: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_expansion_panel, { title: "Which is better WiFi or Broadband?" }, {
                  text: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_expansion_panel, { title: "How to check Jtel broadband usage?" }, {
                  text: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_expansion_panel, { title: "How can I get Jtel broadband connection?" }, {
                  text: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_expansion_panel, { title: "Is Jtel broadband Wireless?" }, {
                  text: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_expansion_panel, { title: "How to change my existing Jtel broadband post-paid plan?" }, {
                  text: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_expansion_panel, { title: "How is Jtel Smart Fiber better than the regular broadband connection?" }, {
                  text: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_jt_need_guidance),
    _createVNode(_component_jt_footer)
  ], 64))
}